export default __webpack_public_path__ + "static/media/Ballroll_00258.3deffd8f.png";